import { AdobePageLoadEvent } from './adobe-page-load';
import { IngredientsPageLoadEvent } from '@/services/analytics/events';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';
import { WebPageDetails } from '../models';

export class AdobeIngredientsPageLoadEvent extends AdobePageLoadEvent {
  pageLoadName = 'ingredients';

  constructor(event: IngredientsPageLoadEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    if(!store.state.adobe.hasIngredientsPageBeenViewed) {
      services.analytics.setIngredientsPageHasBeenViewed();
    }
    Object.assign(this.web.webPageDetails, {   
      pageType: 'page',
      siteSection: 'nutrition',
      name: 'ingredients',
      pageViews: { value: 1 },
    } as WebPageDetails)

  }
}
